import { useDispatch, useSelector } from "react-redux";
import { useMemo, useState } from "react";
import { useRouter } from "next/router";
import { isProductInBasket } from "~/utils/isProductInBasket";
import styles from "./index.module.scss";
import { showPopup } from "/redux/action-creaters/popup";
import { popupTypes } from "/redux/reducers/popupReducer";
import { ApiClient } from "/api/client";
import Button from "../../../../common/button";
import { getBacket } from "../../../../../redux/action-creaters/basket";
import { isMoreThanOneYearAgo } from "../../../../../utils";
import {
  CART_GOALS,
  ECOMMERCE_LISTS,
  reachCartGoal,
  useEcommerce,
} from "../../../../../utils/tracking";

export default function Buttons({ product }) {
  const productId = product.ID;
  const catalog = product.CATALOG;

  const dispatch = useDispatch();
  const [isAddingToCart, setIsAddingToCart] = useState(false);

  const { basket } = useSelector((state) => state.cart);

  const isInCart = useMemo(
    () => isProductInBasket(basket, product),
    [basket, product],
  );

  const isAlailable = useMemo(() => {
    return catalog.AVAILABLE;
  }, [catalog]);

  const price = useMemo(() => {
    return catalog.MIN_PRICE;
  }, [catalog]);

  const edostMinPriceCorrected = useMemo(() => {
    return 0;
  }, [catalog]);

  const priceWithCity = useMemo(() => {
    return price + edostMinPriceCorrected;
  }, [edostMinPriceCorrected]);

  const router = useRouter();
  const { user } = useSelector((state) => state.user);
  const { trackAdd } = useEcommerce();

  return (
    <>
      {isAlailable ? (
        <>
          <div className={styles.Buttons}>
            <Button
              test="addToCartButton"
              type={isInCart ? "outline" : ""}
              onClick={async () => {
                if (!isInCart) {
                  setIsAddingToCart(true);
                  await ApiClient.basket.addProductToBasket(
                    product.ID,
                    product.CART_PROPS || null,
                  );
                  await dispatch(getBacket(true));
                  await dispatch(showPopup(popupTypes.cart));
                  setIsAddingToCart(false);

                  reachCartGoal(CART_GOALS.addToCart, user);
                  trackAdd(product, { list: ECOMMERCE_LISTS.catalog });
                } else {
                  router.push("/personal/cart/");
                }
              }}
              label={isInCart ? "В корзине" : "Купить"}
              isLoading={isAddingToCart}
            />
            <span
              onClick={() => {
                dispatch(
                  showPopup(popupTypes.buyOneClick, {
                    id: productId,
                    price: priceWithCity,
                  }),
                );
              }}
              data-test="buyOneClickButton"
              aria-label="Заказать в 1 клик"
            >
              Заказать в 1 клик
            </span>
          </div>
        </>
      ) : (
        <>
          <link itemProp="availability" href="http://schema.org/OutOfStock" />
          <div className={styles.ButtonsEmpty}>
            <Button
              type="outline"
              label={"Подобрать аналог"}
              test="findAnalogButton"
              onClick={() => {
                dispatch(
                  showPopup(popupTypes.similarProduct, {
                    name: `${product.NAME} (арт ${product.ARTICLE?.VALUE}) (id ${product.ID})`,
                    id: productId,
                  }),
                );
              }}
            />

            {!isMoreThanOneYearAgo(product.TIMESTAMP_X) && (
              <div
                className={styles.Subscribe}
                data-test="subscribeButton"
                onClick={() => {
                  dispatch(
                    showPopup(popupTypes.subscribeProduct, {
                      name: `${product.NAME} (арт ${product.ARTICLE?.VALUE}) (id ${product.ID})`,
                      id: productId,
                    }),
                  );
                }}
              >
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                  <path d="M439.39 362.29c-19.32-20.76-55.47-51.99-55.47-154.29 0-77.7-54.48-139.9-127.94-155.16V32c0-17.67-14.32-32-31.98-32s-31.98 14.33-31.98 32v20.84C118.56 68.1 64.08 130.3 64.08 208c0 102.3-36.15 133.53-55.47 154.29-6 6.45-8.66 14.16-8.61 21.71.11 16.4 12.98 32 32.1 32h383.8c19.12 0 32-15.6 32.1-32 .05-7.55-2.61-15.27-8.61-21.71zM67.53 368c21.22-27.97 44.42-74.33 44.53-159.42 0-.2-.06-.38-.06-.58 0-61.86 50.14-112 112-112s112 50.14 112 112c0 .2-.06.38-.06.58.11 85.1 23.31 131.46 44.53 159.42H67.53zM224 512c35.32 0 63.97-28.65 63.97-64H160.03c0 35.35 28.65 64 63.97 64z" />
                </svg>
              </div>
            )}
          </div>
        </>
      )}
    </>
  );
}
